export default [
  {
    path: '/company/contact-us',
    name: 'contact-us',
    component: () => import(/* webpackChunkName: 'PageContactUs' */ '../PageContactUs'),
    meta: {
      store: ['page/getPageData'],
    },
  },
];
